import { UserContextState } from "./types";

export const USER_STATE_DEFAULT: UserContextState = {
  // You can define any default state value here
  user: null,
};
